import { usePlaidLink } from 'react-plaid-link';
import getConfig from 'constants/config/plaid';

export default (onSuccess, onExit, token = null, redirect = false) => {
  const config = getConfig(onSuccess, onExit, token);
  if (redirect) {
    config.receivedRedirectUri = window.location.href;
  }
  const { open, ready, error } = usePlaidLink(config);
  return [open, ready, error];
};
